"use strict";
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _construct(Parent, args, Class) {
    if (_is_native_reflect_construct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _set_prototype_of(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrap_native_super = function wrapNativeSuper(Class) {
        if (Class === null || !_is_native_function(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _get_prototype_of(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _set_prototype_of(Wrapper, Class);
    };
    return _wrap_native_super(Class);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NO_RESPONSE_STATUS_CODE = exports.FormattedAxiosError = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _trimText = require("./trimText");
/**
 * Represents a status code of `0` to indicate that no response was received from the server.
 *
 * @remarks
 * This constant is used in scenarios where the HTTP request did not reach the server or the server
 * did not provide a valid response, such as when the network is unavailable, the request times out,
 * or there's a CORS error. Since `0` is not a valid HTTP status code, it serves as a special
 * placeholder to signal the absence of any server response.
 */ var NO_RESPONSE_STATUS_CODE = exports.NO_RESPONSE_STATUS_CODE = 0;
/**
 * This formats ExtendedAxiosError into more readable object for logging only
 */ var FormattedAxiosError = /*#__PURE__*/ function(Error1) {
    _inherits(FormattedAxiosError, Error1);
    function FormattedAxiosError(axiosError) {
        _class_call_check(this, FormattedAxiosError);
        var _this;
        _this = _call_super(this, FormattedAxiosError, [
            "Axios Error: ".concat(axiosError.message)
        ]);
        (0, _defineProperty2.default)(_this, "baseUrl", void 0);
        (0, _defineProperty2.default)(_this, "pathname", void 0);
        (0, _defineProperty2.default)(_this, "method", void 0);
        (0, _defineProperty2.default)(_this, "statusCode", void 0);
        (0, _defineProperty2.default)(_this, "statusText", void 0);
        (0, _defineProperty2.default)(_this, "responseBody", null);
        (0, _defineProperty2.default)(_this, "callstack", void 0);
        _this.name = 'FormattedAxiosError';
        _this.baseUrl = axiosError.baseUrl;
        _this.pathname = axiosError.pathname;
        _this.method = axiosError.method;
        _this.statusCode = axiosError.statusCode;
        _this.statusText = axiosError.statusText;
        // No need to pass body on 404 and empty body
        if (_this.statusCode !== 404 && axiosError.responseBody != null) {
            if (process.env.NODE_ENV === 'production') {
                // Make sure that body is trimmed so we won't overfill Application Insights
                _this.responseBody = (0, _trimText.trimText)(JSON.stringify(axiosError.responseBody));
            } else {
                _this.responseBody = JSON.stringify(axiosError.responseBody, null, 2);
            }
        }
        _this.callstack = axiosError.callstack;
        return _this;
    }
    return FormattedAxiosError;
}(_wrap_native_super(Error));
exports.FormattedAxiosError = FormattedAxiosError; //# sourceMappingURL=FormattedAxiosError.js.map
